import { render, staticRenderFns } from "./ArmstrongTemplate.vue?vue&type=template&id=254448ae"
import script from "./ArmstrongTemplate.vue?vue&type=script&lang=js"
export * from "./ArmstrongTemplate.vue?vue&type=script&lang=js"
import style0 from "./ArmstrongTemplate.vue?vue&type=style&index=0&id=254448ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports